module.exports = __webpack_public_path__ + "img/cloudy-night-3.bf91ac0f.svg";